/**
 * This file contains logic related to the Bible Type filter.
 */

/**
 * Supported bible types.
 */
type BibleType = 'Text' | 'Audio' | 'Video';

/**
 * A bible type and how many visible projects include it.
 * (e.g. 'Text' => 5)
 */
type BibleTypeCounts = Map<BibleType, number>

/**
 * Return the bible types available through currently-visible projects.
 * @return BibleTypeCounts
 */
export function getBibleTypes() {
  const bibleTypeCounts: BibleTypeCounts = new Map([
    ['Text', 0],
    ['Audio', 0],
    ['Video', 0]
  ]);
  // Count up the bible types for all the visible projects.
  $('.products-list>li').each(function () {
    const hasText = $(this).attr('data-has-text') === 'true';
    const hasAudio = $(this).attr('data-has-audio') === 'true';
    const hasVideo = $(this).attr('data-has-video') === 'true';
    if (hasText) {
      let count = bibleTypeCounts.get('Text');
      bibleTypeCounts.set('Text', ++count);
    }
    if (hasAudio) {
      let count = bibleTypeCounts.get('Audio');
      bibleTypeCounts.set('Audio', ++count);
    }
    if (hasVideo) {
      let count = bibleTypeCounts.get('Video');
      bibleTypeCounts.set('Video', ++count);
    }
  })
  return bibleTypeCounts;
}

/**
 * Sets the counts displayed next to each bible type in the filter box.
 * @param bibleTypeCounts A map of bible types.
 */
export function setBibleTypeCounts() {
  const bibleTypes: BibleTypeCounts = getBibleTypes();
  $('#bible-type-filter .check-row span.number').each(function () {
    const bibleType = $(this).siblings('label').attr('for') as BibleType;
    $(this).text(`(${bibleTypes.get(bibleType) || 0})`)
  });
}

/**
 * Determine which bible types are currently selected.
 */
export function getSelectedBibleTypes() {
  const selectedBibleTypes = new Set<string>();
  $('#bible-type-filter input:checked').each(function () {
    selectedBibleTypes.add(String($(this).val()));
  })
  return selectedBibleTypes;
}

/**
 * Determine whether a project should be shown based on bible type.
 * @param project The top level project element. (i.e. '.products-list>li')
 * @param selectedBibletypes The selected bible types.
 */
export function showProjectBasedOnBibleType(project: HTMLElement, selectedBibletypes: Set<string>) {
  const hasText = $(project).attr('data-has-text') === 'true';
  const hasAudio = $(project).attr('data-has-audio') === 'true';
  const hasVideo = $(project).attr('data-has-video') === 'true';

  const bibleTypes = new Set();
  if (hasText) {
    bibleTypes.add('Text');
  }
  if (hasAudio) {
    bibleTypes.add('Audio');
  }
  if(hasVideo) {
    bibleTypes.add('Video');
  }

  return Array.from(selectedBibletypes).some(bibleType => bibleTypes.has(bibleType))
    || selectedBibletypes.size === 0;
}

/**
 * Hide any project that doesn't contain a selected bible type.
 * Show all projects if no bible types are selected.
 */
function showHideProjectsByBibleType() {
  const selectedBibleTypes = getSelectedBibleTypes();
  $('.products-list>li').each(function () {
    if (showProjectBasedOnBibleType(this, selectedBibleTypes)) {
      $(this).show();
    } else {
      $(this).hide();
    }
  })
}
